import type { SupportedLocale } from '@erp/shared';

interface FrenchIdentifiersTranslation {
  hint: string;
  sirenInvalid: string;
  siretInvalid: string;
  mismatch: string;
  migrationHint: string;
}

export const frenchIdentifiersTranslations: Record<SupportedLocale, FrenchIdentifiersTranslation> =
  {
    de: {
      hint: 'Optionale französische Kennungen: SIREN mit 9 Ziffern, SIRET mit 14 Ziffern. Leerzeichen werden ignoriert; führende Nullen bleiben erhalten.',
      sirenInvalid: 'SIREN muss genau 9 Ziffern enthalten.',
      siretInvalid: 'SIRET muss genau 14 Ziffern enthalten.',
      mismatch: 'Die ersten 9 Ziffern von SIRET müssen mit SIREN übereinstimmen.',
      migrationHint:
        'Eindeutige gültige Bestandswerte werden einmalig aus den bisherigen Zusatzfeldern übernommen. Originale bleiben erhalten; spätere Änderungen dort werden nicht automatisch übertragen. Ungeklärte Werte bitte prüfen und hier korrigieren.',
    },
    en: {
      hint: 'Optional French identifiers: SIREN has 9 digits and SIRET has 14. Whitespace is ignored; leading zeros are retained.',
      sirenInvalid: 'SIREN must contain exactly 9 digits.',
      siretInvalid: 'SIRET must contain exactly 14 digits.',
      mismatch: 'The first 9 digits of SIRET must match SIREN.',
      migrationHint:
        'Unambiguous valid existing values are copied once from the previous custom fields. Originals are retained; later changes there are not copied automatically. Review unresolved values and correct them here.',
    },
    fr: {
      hint: 'Identifiants français facultatifs : 9 chiffres pour le SIREN, 14 pour le SIRET. Les espaces sont ignorés ; les zéros initiaux sont conservés.',
      sirenInvalid: 'Le SIREN doit contenir exactement 9 chiffres.',
      siretInvalid: 'Le SIRET doit contenir exactement 14 chiffres.',
      mismatch: 'Les 9 premiers chiffres du SIRET doivent correspondre au SIREN.',
      migrationHint:
        'Les valeurs existantes valides et non ambiguës sont reprises une seule fois des anciens champs personnalisés. Les originaux sont conservés ; leurs modifications ultérieures ne sont pas reprises automatiquement. Vérifiez les cas non résolus et corrigez-les ici.',
    },
    es: {
      hint: 'Identificadores franceses opcionales: SIREN de 9 dígitos y SIRET de 14. Se ignoran los espacios y se conservan los ceros iniciales.',
      sirenInvalid: 'SIREN debe contener exactamente 9 dígitos.',
      siretInvalid: 'SIRET debe contener exactamente 14 dígitos.',
      mismatch: 'Los 9 primeros dígitos de SIRET deben coincidir con SIREN.',
      migrationHint:
        'Los valores existentes válidos e inequívocos se copian una sola vez desde los antiguos campos personalizados. Se conservan los originales; sus cambios posteriores no se copian automáticamente. Revise los casos pendientes y corríjalos aquí.',
    },
    tr: {
      hint: 'İsteğe bağlı Fransız kimlik numaraları: SIREN 9, SIRET 14 rakamdır. Boşluklar yok sayılır; baştaki sıfırlar korunur.',
      sirenInvalid: 'SIREN tam olarak 9 rakam içermelidir.',
      siretInvalid: 'SIRET tam olarak 14 rakam içermelidir.',
      mismatch: 'SIRET’in ilk 9 rakamı SIREN ile aynı olmalıdır.',
      migrationHint:
        'Mevcut geçerli ve açık değerler eski ek alanlardan bir kez aktarılır. Özgün değerler korunur; daha sonraki değişiklikler otomatik aktarılmaz. Çözümlenmemiş değerleri kontrol edip burada düzeltin.',
    },
  };
